import { call, put, takeEvery, all } from "redux-saga/effects"

// Crypto Redux States
import { GET_PROCESSO_COMPLETO, UPDATE_PROCESSO, POST_PROCESSO_SUCCESS } from "./actionTypes"
import { getProcessosSuccess, getProcessosFail, updateProcessoSuccess, updateProcessoFail, postProcessoSuccess, postProcessoMsg } from "./actions"

//Include Both Helper File with needed methods
import { getProcessoCompleto, updateProcesso, postProcesso } from "helpers/blopsleads_helper"

function* fetchProcessoCompleto({ processoId }) {
  try {
    const response = yield call(getProcessoCompleto, processoId);
    yield put(getProcessosSuccess(response));
  } catch (error) {
    yield put(getProcessosFail(error));
  }
}

function* onUpdateProcesso({ payload: data }) {
  try {
    const response = yield call(updateProcesso, data)

    yield put(updateProcessoSuccess(response))
  } catch (error) {
    yield put(updateProcessoFail(error))
  }
}

function* onCreateProcesso({ payload: processos }) {
  try {
    const responses = yield all(processos.map(processo => call(postProcesso, processo)))
    if (responses.length > 1 && responses.every(response => response.message === 'Processo cadastrado com sucesso.')) {
      yield put(postProcessoMsg({ message: "Todos os processos foram cadastrados com sucesso." }));
    } else {
      yield put(postProcessoMsg({ message: "Processo cadastrado com sucesso." }));
    }
  } catch (error) {
    console.log("ERR_PRROO", error.response.data.message);
    yield put(postProcessoMsg({message: error.response.data.message}));
  }
}

function* ProcessoSaga() {
  yield takeEvery(GET_PROCESSO_COMPLETO, fetchProcessoCompleto)
  yield takeEvery(UPDATE_PROCESSO, onUpdateProcesso)
  yield takeEvery(POST_PROCESSO_SUCCESS, onCreateProcesso);
}

export default ProcessoSaga
